import { qlubSessionStorage } from '../../../service/storage/sessionStorage';

const redirectionStorageKey = 'qlub.auth.oauth.redirection';

export const setRedirection = (link: string) => {
    qlubSessionStorage.set(redirectionStorageKey, link);
};

export const getRedirection = () => {
    return qlubSessionStorage.get(redirectionStorageKey);
};

export const removeRedirection = () => {
    qlubSessionStorage.remove(redirectionStorageKey);
};
